/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PasskeyRegistrationOptionsResponse { 
    /**
     * Challenge casuale codificato in Base64URL
     */
    challenge: string;
    /**
     * Identificativo della Relying Party (dominio)
     */
    rp_id: string;
    /**
     * Nome della Relying Party
     */
    rp_name: string;
    /**
     * Identificativo univoco dell\'utente codificato in Base64URL
     */
    user_id: string;
    /**
     * Etichetta utente per il gestore passkey del dispositivo: email, oppure nome+cognome, oppure identificativo. Sempre valorizzata, mai null/vuota. NON e\' un identificatore ne\' univoca.
     */
    user_name: string;
}

